export default function($form){
  var dialog=$form.dialog;
  if (dialog) {
    if(dialog.$parent.params.secondfunc){
      dialog.$parent.params.secondfunc(dialog.$parent.updatedData)
    }
    dialog.hide();
  }
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/form-close.js